import { render, staticRenderFns } from "./mailbox-settings-conversation-rules.vue?vue&type=template&id=55462a0a&scoped=true&"
import script from "./mailbox-settings-conversation-rules.vue?vue&type=script&lang=ts&"
export * from "./mailbox-settings-conversation-rules.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-settings-conversation-rules.vue?vue&type=style&index=0&id=55462a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55462a0a",
  null
  
)

export default component.exports